import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    isRetrieveUnavailabilityReasonsRequestFailure() {
      return getState().request.isFailure;
    },
    isRetrieveUnavailabilityReasonsRequestPending() {
      return getState().request.isPending;
    },
    isRetrieveUnavailabilityReasonsRequestSuccess() {
      return getState().request.isSuccessful;
    },
    getUnavailabilityReasons() {
      return getState().reasons;
    },
  };
}

export { createSelector };
